import { Edit3, Check, X } from "lucide-react";

export default function SectionCard({
  title,
  icon,
  children,
  onSave,
  editing,
  onEdit,
  onCancel,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  onSave: () => void;
  editing: boolean;
  onEdit: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-50">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-xl bg-violet-50 flex items-center justify-center text-violet-600">
            {icon}
          </div>
          <span
            className="text-[15px] text-slate-900"
            style={{ fontWeight: 700 }}
          >
            {title}
          </span>
        </div>
        {editing ? (
          <div className="flex gap-2">
            <button
              onClick={onCancel}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[12px] text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors"
              style={{ fontWeight: 600 }}
            >
              <X className="w-3.5 h-3.5" /> Cancel
            </button>
            <button
              onClick={onSave}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[12px] text-white bg-gradient-to-r from-violet-600 to-purple-600 shadow-sm hover:shadow-md transition-all"
              style={{ fontWeight: 600 }}
            >
              <Check className="w-3.5 h-3.5" /> Save
            </button>
          </div>
        ) : (
          <button
            onClick={onEdit}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[12px] text-violet-600 bg-violet-50 hover:bg-violet-100 transition-colors"
            style={{ fontWeight: 600 }}
          >
            <Edit3 className="w-3.5 h-3.5" /> Edit
          </button>
        )}
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}
